export default function SiteFooter() {
  return (
    <footer className="bg-foreground-950 text-background-200">
      <div className="w-full px-4 md:px-8 pt-12 md:pt-16 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-2 max-w-md">
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center font-heading font-extrabold text-background-50 text-lg">
                91
              </span>
              <span className="font-heading font-extrabold text-background-50 text-lg">91动漫</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              91动漫是面向动漫爱好者的内容门户，聚焦最新动漫资讯、动画作品介绍与热门推荐。我们希望用清晰的信息结构，帮你在每一季新番里快速找到值得追的那一部。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["动漫资讯", "作品图鉴", "新番速报", "深度推荐"].map((tag) => (
                <span
                  key={tag}
                  className="px-2.5 py-1 rounded-full text-xs bg-background-50/10 text-background-200 font-label"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">站点导航</h4>
            <ul className="space-y-2.5 text-sm">
              {[
                { to: "/", label: "首页" },
                { to: "/news", label: "动漫资讯" },
                { to: "/anime", label: "动漫作品" },
                { to: "/search", label: "搜索" },
                { to: "/about", label: "关于我们" },
              ].map((item) => (
                <li key={item.to}>
                  <a
                    href={item.to}
                    className="text-background-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">联系与说明</h4>
            <ul className="space-y-2.5 text-sm text-background-300">
              <li className="flex items-start gap-2">
                <span className="w-4 h-4 mt-0.5 flex items-center justify-center shrink-0 text-primary-400">
                  <i className="ri-mail-line text-sm" />
                </span>
                <a href="mailto:hello@91anime.example" className="hover:text-primary-400 transition-colors cursor-pointer break-all">
                  hello@91anime.example
                </a>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-4 h-4 mt-0.5 flex items-center justify-center shrink-0 text-primary-400">
                  <i className="ri-time-line text-sm" />
                </span>
                <span>内容更新：每日 09:00 / 21:00</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-4 h-4 mt-0.5 flex items-center justify-center shrink-0 text-primary-400">
                  <i className="ri-information-line text-sm" />
                </span>
                <span>本站不提供在线播放与下载</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-background-400">
          <p>© 2025 91动漫 · 保留所有权利</p>
          <p className="leading-relaxed">
            站内作品信息与评分为演示内容，版权归原作品权利方所有。
          </p>
        </div>
      </div>
    </footer>
  );
}